export default "/images/vendor/flag-icon-css/flags/1x1/nz.svg?37be84f4206a0eae405bbd495ecaaa69";